import { render, staticRenderFns } from "./CharactersTechPowers.vue?vue&type=template&id=54f363f5&lang=pug&"
import script from "./CharactersTechPowers.vue?vue&type=script&lang=ts&"
export * from "./CharactersTechPowers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports